module.exports = __webpack_public_path__ + "static/media/right-arrow.3ee9dc35.svg";